import "./paragraph.scss";

export const Paragraph = ({ text }) => {
  return (
    <div className="section-paragraph">
      <p>{text}</p>
    </div>
  );
};
